import { render, staticRenderFns } from "./NuevoMovimientoBasicoLogi.vue?vue&type=template&id=ca8926ba&scoped=true&"
import script from "./NuevoMovimientoBasicoLogi.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimientoBasicoLogi.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimientoBasicoLogi.vue?vue&type=style&index=0&id=ca8926ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8926ba",
  null
  
)

export default component.exports